import { createApp } from 'vue';
import App from './components/app.vue';
import mapFactory from '../../map/ol/main';

const app = createApp(App);
app.mount('#app');

mapFactory.createMap('map');
